import { IntlFormatters } from 'react-intl';
import { sportCategories } from '../../data-types/sports/sportsConstants';

const getBasketballTranslatedHeader = (stateHeader: string, formatMessage: IntlFormatters['formatMessage']) => {
  if (
    stateHeader.toUpperCase().includes('BREAK') ||
    stateHeader.toUpperCase().includes('HALF TIME') ||
    stateHeader.toUpperCase().includes('HALFTIME')
  ) {
    return formatMessage({ id: 'sports.break' }).toUpperCase();
  }

  const periodMark = stateHeader.charAt(0).toUpperCase();
  const period = stateHeader.charAt(1);

  if (['P', 'Q'].includes(periodMark) && !isNaN(Number(period))) {
    return `${formatMessage({ id: 'sports.basketball_period' })}${stateHeader.slice(1)}`;
  }

  return stateHeader;
};

const getEFootballTranslatedHeader = (stateHeader: string, formatMessage: IntlFormatters['formatMessage']) => {
  // Possible formats:
  // 1ST HALF 7’
  // 2ND HALF 2’
  // HALFTIME
  // FINISHED

  const FIRST_HALF = '1ST HALF';
  const SECOND_HALF = '2ND HALF';
  const HALFTIME = 'HALFTIME';
  const FINISHED = 'FINISHED';

  if (stateHeader.toUpperCase().includes(FIRST_HALF)) {
    return formatMessage({ id: 'common.first_half' }).toUpperCase() + stateHeader.slice(FIRST_HALF.length);
  }

  if (stateHeader.toUpperCase().includes(SECOND_HALF)) {
    return formatMessage({ id: 'common.second_half' }).toUpperCase() + stateHeader.slice(SECOND_HALF.length);
  }

  if (stateHeader.toUpperCase().includes(HALFTIME)) {
    return formatMessage({ id: 'sports.half_time' }).toUpperCase();
  }

  if (stateHeader.toUpperCase().includes(FINISHED)) {
    return formatMessage({ id: 'event.finished' }).toUpperCase();
  }

  return stateHeader;
};

export const getTranslatedStateHeader = (stateHeader: string, sportId: number, formatMessage: IntlFormatters['formatMessage']) => {
  switch (sportId) {
    case sportCategories.E_BASKETBALL:
      return getBasketballTranslatedHeader(stateHeader, formatMessage);

    case sportCategories.E_FOOTBALL:
      return getEFootballTranslatedHeader(stateHeader, formatMessage);

    default:
      return stateHeader;
  }
};
